import { Endpoints } from "@config/Endpoints";
import { customAxios } from "@infrastructure/api/CustomAxios";

export const LoginResource = {
  requestCode: (phone: string) => {
    return customAxios.post(Endpoints.auth.request_verify, {
      phone: phone,
    });
  },

  requestCodeByEmail: (email: string) => {
    return customAxios.post(Endpoints.auth.request_verify_by_email, {
      email: email,
    });
  },
};
